import { render, staticRenderFns } from "./RecoverPayment.vue?vue&type=template&id=256df704"
import script from "./RecoverPayment.vue?vue&type=script&lang=js"
export * from "./RecoverPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports